import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > p {
    margin-bottom: 10px;
  }

  & > a {
    text-decoration: none;
  }

  & button {
    padding: 0 10px;
  }
`;
